import { append, createElement, getElementById, setId } from "@acng/frontend-bounty";
import { STRING, typeguard } from "@acng/frontend-bounty/assert";
import { TAGNAME_TEMPLATE } from "@acng/frontend-bounty/types";
/**
 * @typedef {import("../model/resource.js").ResourceElement} ResourceElement
 */
/**
 * @param {ResourceElement} resource
 * @param {string} id
 * @returns {ResourceElement}
 */
export const create = (resource, id) => {
    ASSERT: {
        typeguard("resource-id", id, STRING);
        console.assert(!getElementById(id, resource.content), "duplicate resource", {
            content: resource.content,
            id,
        });
    }
    /**
     * @type {ResourceElement}
     */
    const element = createElement(TAGNAME_TEMPLATE);
    setId(element, id);
    append(resource.content, element);
    return element;
};
